import { render, staticRenderFns } from "./KitZohoDeskTicketsCard.vue?vue&type=template&id=cf2f4dae"
import script from "./KitZohoDeskTicketsCard.vue?vue&type=script&lang=js"
export * from "./KitZohoDeskTicketsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports